import {
  fetchOperators,
  getAssets,
  getCabinetTypes,
  getCategories,
  getDepots,
  getGameTitles,
  getGroupings,
  getManufacturers,
  getNoteAcceptorModels,
  getSuppliers,
  getOwnershipProfiles,
  getStatuses,
  getVariants,
  loadAsset,
  loadCabinetType,
  loadCategory,
  loadDepot,
  loadGameTitle,
  loadManufacturer,
  loadNoteAcceptorModel,
  loadSupplier,
  newAsset,
  newCabinetType,
  newCategory,
  newDepot,
  newGameTitle,
  newManufacturer,
  newSupplier,
  newNoteAcceptorModel,
  updateAsset,
  updateCabinetType,
  updateCategory,
  updateDepot,
  updateSupplier,
  updateGameTitle,
  updateManufacturer,
  updateNoteAcceptorModel,
} from "@actions/index";
import {
  confirmModal,
  setAssetOwnershipModal,
  showInstallHistoryModal,
  showSuccessAlert,
} from "@actions/modals";
import { deleteAsset, getAssetsDownload } from "@api/egm";
import EGMFilters from "@components/assetAdmin/AssetAdminFilters";
import EGMTree from "@components/assetAdmin/AssetAdminTree";
import BaseSettings from "@components/systemAdmin/BaseSettings";
import OptionsList from "@components/systemAdmin/OptionsList";
import { handleDownload } from "@helpers/downloads";
import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Checkbox,
  Dimmer,
  Dropdown,
  Grid,
  Header,
  Label,
  Loader,
} from "semantic-ui-react";

class AssetAdminView extends BaseSettings {
  constructor() {
    super();
    this.state = {
      ...this.state, // spread in parent's state
      searchParams: {
        selectedOperator: null,
        selectedGrouping: 0,
        selectedCategory: -1,
        searchText: "",
        selectedManufacturer: -1,
        selectedGameTitle: -1,
        selectedCabinetType: -1,
        selectedNoteAcceptorModel: -1,
        selectedStatus: -1,
        selectedVariant: -1,
        selectedDepot: -1,
        selectedSupplier: -1,
        selectedOwnershipProfile: -1,
        assetRegisterSummary: true,
      },
      filters: {
        manufacturers: [],
        suppliers: [],
        categories: [],
        gameTitles: [],
        cabinetTypes: [],
        statuses: [],
        selectedStatuses: [],
        variants: [],
        depots: [],
        noteAcceptorModels: [],
        groupings: [],
        profiles: [],
      },

      selectedNode: { id: null, name: null, type: null, main: [] },
      grid: { data: [], rowDef: [], headerDef: [] },
      selectedOptions: [],
      assets: [],
      loading: false,
      doQuestion: false,
      questionText: "",
      createAnother: false,
      doDelete: false,
    };
  }

  handleSelection = (name, value) => {
    this.setState({
      searchParams: { ...this.state.searchParams, [name]: value },
    });
  };

  componentDidMount = () => {
    this.getGroupings();
    this.getStatuses();
    this.getVariants();

    if (this.props.operators.length === 1) {
      this.setState(
        {
          searchParams: {
            ...this.state.searchParams,
            selectedOperator: this.props.operators[0].value,
          },
        },
        () => this.updateFilters(),
      );
    }
  };

  handleRefresh = async () => {
    const {
      selectedOperator,
      selectedGrouping,
      selectedCategory,
      searchText,
      selectedManufacturer,
      selectedGameTitle,
      selectedCabinetType,
      selectedNoteAcceptorModel,
      selectedVariant,
      selectedDepot,
      selectedOwnershipProfile,
      selectedSupplier,
      assetRegisterSummary,
    } = this.state.searchParams;

    const { statuses } = this.state.filters;

    this.setState({ loading: true }, () => {
      getAssets(
        selectedOperator,
        selectedCategory,
        selectedManufacturer,
        selectedCabinetType,
        selectedGameTitle,
        selectedNoteAcceptorModel,
        statuses,
        selectedVariant,
        selectedGrouping,
        searchText,
        selectedDepot,
        selectedOwnershipProfile,
        selectedSupplier,
        assetRegisterSummary,
      ).then(
        ({ statuses, assets }) => {
          this.setState({
            assets,
            filters: { ...this.state.filters, statuses },
            loading: false,
          });
        },
        () => this.setState({ loading: false }),
      );
    });
  };

  handleNew = (selectedOptions, selectedNode, grid = null) => {
    this.setState({
      selectedOptions: selectedOptions.main
        ? selectedOptions
        : { main: selectedOptions, ownership: [], operational: [] },
      changed: [],
      selectedNode,
      grid,
    });
  };

  onNewClick = (type) => {
    this.setState({ doDelete: false }, () => {
      switch (type) {
        case "MU":
          return newManufacturer(this.state.searchParams.selectedOperator).then(
            (selectedOptions) =>
              this.handleNew(selectedOptions, {
                id: 0,
                name: "New Manufacturer",
                type: "MU",
              }),
          );

        case "GT":
          return newGameTitle(this.state.searchParams.selectedOperator).then(
            (selectedOptions) =>
              this.handleNew(selectedOptions, {
                id: 0,
                name: "New Game Title",
                type: "GT",
              }),
          );

        case "MT":
          return newCategory(this.state.searchParams.selectedOperator).then(
            (selectedOptions) =>
              this.handleNew(selectedOptions, {
                id: 0,
                name: "New Category",
                type: "MT",
              }),
          );

        case "DP":
          return newDepot(this.state.searchParams.selectedOperator).then(
            (selectedOptions) =>
              this.handleNew(selectedOptions, {
                id: 0,
                name: "Depot",
                type: "DP",
              }),
          );

        case "CB":
          return newCabinetType(this.state.searchParams.selectedOperator).then(
            (selectedOptions) =>
              this.handleNew(selectedOptions, {
                id: 0,
                name: "New Cabinet Type",
                type: "CB",
              }),
          );

        case "NA":
          return newNoteAcceptorModel(
            this.state.searchParams.selectedOperator,
          ).then((selectedOptions) =>
            this.handleNew(selectedOptions, {
              id: 0,
              name: "Note Acceptor Model",
              type: "NA",
            }),
          );

        case "SP":
          return newSupplier(this.state.searchParams.selectedOperator).then(
            (selectedOptions) =>
              this.handleNew(selectedOptions, {
                id: 0,
                name: "Supplier",
                type: "SP",
              }),
          );

        default:
          return newAsset(this.state.searchParams.selectedOperator).then(
            (selectedOptions) =>
              this.handleNew(selectedOptions, {
                id: 0,
                name: "New Machine Asset",
                type: "MA",
              }),
          );
      }
    });
  };

  loadNode = async (item) => {
    switch (item.type) {
      case "MU":
        return loadManufacturer(item.id);

      case "GT":
        return loadGameTitle(item.id);

      case "MA":
        return loadAsset(item.id);

      case "MT":
        return loadCategory(item.id);

      case "DP":
        return loadDepot(item.id);

      case "CB":
        return loadCabinetType(item.id);

      case "NA":
        return loadNoteAcceptorModel(item.id);

      case "SP":
        return loadSupplier(item.id);
      default:
        return { main: [], operational: [], ownership: [], grid: null };
    }
  };

  handleNodeClick = (item) => {
    this.loadNode(item).then((response) => {
      const { doQuestion, doDelete, questionText } = response;
      this.setState({ doQuestion, doDelete, questionText }, () => {
        this.handleNew(
          response.assetUI
            ? response.assetUI
            : { main: response.options, operational: [], ownership: [] },
          item,
          response.grid,
        );
      });
    });
  };

  handleReload = () => {
    const options = this.getAll(this.state.selectedOptions);
    const { selectedNode } = this.state;
    this.setState({ loading: true }, () => {
      updateAsset(
        selectedNode.id,
        this.state.searchParams.selectedOperator,
        false,
        options,
      ).then(
        (selectedOptions) => {
          this.setState({ selectedOptions, changed: [], loading: false });
        },
        () => this.setState({ loading: false }),
      );
    });
  };

  findById = (array, id) => {
    for (const node of array) {
      if (node.id === id) return node;
      if (node.children) {
        const child = this.findById(node.children, id);
        if (child) return child;
      }
    }
  };

  handleSave = async () => {
    const changed = this.getAll(this.state.selectedOptions);
    const { selectedNode } = this.state;

    const callback = async (doUpdate) => {
      this.setState({ loading: true }, () => {
        this.updateRequest(selectedNode, changed, doUpdate).then(
          (response) => {
            this.setState({ changed: [], loading: false }, () => {
              this.props.showSuccessAlert(
                selectedNode.id > 0
                  ? "Your changes were saved successfully!"
                  : "Item successfully created!",
              );
              this.handleRefresh().then(() => {
                const node = this.findById(this.state.assets, response);
                if (response.main) {
                  this.setState({ createAnother: false }, () => {
                    this.handleNew(response, {
                      id: 0,
                      name: selectedNode.name,
                      type: selectedNode.type,
                    });
                  });
                  return;
                }

                if (!node) {
                  return this.onNewClick(selectedNode.type);
                }

                this.handleNodeClick(node);
              });
            });
          },
          () => this.setState({ loading: false }),
        );
      });
    };

    if (this.state.doQuestion) {
      this.props.confirmModal(
        this.state.questionText,
        true,
        () => callback(true),
        () => callback(false),
        true,
      );
    } else {
      callback(true);
    }
  };

  onOperatorChange = (event, data) => {
    this.setState(
      {
        searchParams: {
          ...this.state.searchParams,
          selectedOperator: data.value,
        },
      },
      () => this.updateFilters(),
    );
  };

  setFilters = (filter) => {
    this.setState({ filters: { ...this.state.filters, ...filter } });
  };

  getManufacturers = () => {
    getManufacturers(this.state.searchParams.selectedOperator).then(
      (manufacturers) => {
        this.setFilters({ manufacturers });
      },
    );
  };

  getCategories = () => {
    getCategories(this.state.searchParams.selectedOperator).then(
      (categories) => {
        this.setFilters({ categories });
      },
    );
  };

  getSuppliers = () => {
    getSuppliers(this.state.searchParams.selectedOperator).then((suppliers) => {
      this.setFilters({ suppliers });
    });
  };

  getNoteAcceptorModels = () => {
    getNoteAcceptorModels(this.state.searchParams.selectedOperator).then(
      (noteAcceptorModels) => {
        this.setFilters({ noteAcceptorModels });
      },
    );
  };

  getDepots = () => {
    getDepots(this.state.searchParams.selectedOperator).then((depots) => {
      this.setFilters({ depots });
    });
  };

  getCabinetTypes = () => {
    getCabinetTypes(this.state.searchParams.selectedOperator).then(
      (cabinetTypes) => {
        this.setFilters({ cabinetTypes });
      },
    );
  };

  getGameTitles = () => {
    getGameTitles(this.state.searchParams.selectedOperator).then(
      (gameTitles) => {
        this.setFilters({ gameTitles });
      },
    );
  };

  getOwnershipProfiles = () => {
    getOwnershipProfiles(this.state.searchParams.selectedOperator).then(
      (profiles) => {
        this.setFilters({ profiles });
      },
    );
  };

  updateFilters = () => {
    this.getManufacturers();
    this.getCategories();
    this.getNoteAcceptorModels();
    this.getDepots();
    this.getCabinetTypes();
    this.getGameTitles();
    this.getSuppliers();
    this.getOwnershipProfiles();
  };

  getVariants = () => {
    getVariants().then((variants) => {
      this.setFilters({ variants });
    });
  };

  getGroupings = () => {
    getGroupings().then((groupings) => {
      this.setFilters({ groupings });
    });
  };

  getStatuses = () => {
    getStatuses().then((statuses) => {
      this.setFilters({ statuses });
    });
  };

  updateRequest = async (selectedNode, changed, doUpdate = true) => {
    const { createAnother } = this.state;
    switch (selectedNode.type) {
      case "MU":
        return await updateManufacturer(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          changed,
          () => this.getManufacturers(),
        );

      case "GT":
        return await updateGameTitle(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          changed,
          () => this.getGameTitles(),
        );

      case "MA":
        return await updateAsset(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          true,
          changed,
          createAnother,
        );

      case "MT":
        return await updateCategory(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          changed,
          () => this.getCategories(),
        );

      case "DP":
        return await updateDepot(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          changed,
          () => this.getDepots(),
        );

      case "CB":
        return await updateCabinetType(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          changed,
          doUpdate,
          () => this.getCabinetTypes(),
        );

      case "NA":
        return await updateNoteAcceptorModel(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          changed,
          () => this.getNoteAcceptorModels(),
        );

      case "SP":
        return await updateSupplier(
          selectedNode.id,
          this.state.searchParams.selectedOperator,
          changed,
          () => this.getSuppliers(),
        );

      default:
        break;
    }
  };

  handleDelete = () => {
    const callback = async () => {
      const { id } = this.state.selectedNode;
      deleteAsset(id).then((response) =>
        this.props.showSuccessAlert(response, "Success", async () =>
          this.setState(
            {
              selectedNode: {
                id: null,
                name: null,
                type: null,
                main: [],
                ownership: [],
                operational: [],
              },
            },
            () => this.handleRefresh(),
          ),
        ),
      );
    };

    this.props.confirmModal(
      "Are you sure you want to delete this machine asset?",
      true,
      callback,
    );
  };

  handleDownload = () => {
    const {
      selectedOperator,
      selectedGrouping,
      selectedCategory,
      searchText,
      selectedManufacturer,
      selectedGameTitle,
      selectedCabinetType,
      selectedNoteAcceptorModel,
      selectedVariant,
      selectedDepot,
      selectedOwnershipProfile,
      selectedSupplier,
      assetRegisterSummary,
    } = this.state.searchParams;

    this.setState({ loading: true }, () => {
      const { statuses } = this.state.filters;
      getAssetsDownload(
        selectedOperator,
        selectedCategory,
        selectedManufacturer,
        selectedCabinetType,
        selectedGameTitle,
        selectedNoteAcceptorModel,
        statuses,
        selectedVariant,
        selectedGrouping,
        searchText,
        selectedDepot,
        selectedOwnershipProfile,
        selectedSupplier,
        assetRegisterSummary,
      ).then(
        (response) => {
          this.setState({ loading: false }, () => handleDownload(response));
        },
        () => this.setState({ loading: false }),
      );
    });
  };

  render() {
    const { selectedOperator } = this.state.searchParams;
    const { loading, selectedNode, createAnother, filters, searchParams } =
      this.state;
    const { assetRegisterSummary } = searchParams;
    const { statuses } = filters;

    return (
      <Grid columns="2" className="height-100 gs-flex-container-vertical">
        <Grid.Row className="flex-stretch">
          <Grid.Column tablet="16" computer="4" largeScreen="3" widescreen="2">
            <EGMFilters
              onChange={this.handleSelection}
              onOperatorChange={this.onOperatorChange}
              onRefresh={this.handleRefresh}
              loading={this.state.loading}
              filters={this.state.filters}
              searchParams={this.state.searchParams}
              disableDownload={this.state.assets.length < 1}
              onDownloadClick={this.handleDownload}
            />
          </Grid.Column>
          <Grid.Column
            tablet="16"
            computer="12"
            largeScreen="13"
            widescreen="14"
            className="gs-flex-container-vertical"
          >
            <div className="mb-0_5">
              {statuses.map((status) => (
                <Label
                  style={{ border: "1px solid" }}
                  inverted
                  color={status.colour.toLowerCase()}
                  basic={!status.selected}
                  className="clickable"
                  onClick={() => {
                    this.setFilters({
                      statuses: [
                        ...statuses.map((x) => {
                          return {
                            ...x,
                            selected:
                              x.id === status.id ? !x.selected : x.selected,
                          };
                        }),
                      ],
                    });
                  }}
                >
                  {status.name}
                  <Label.Detail>{status.qty}</Label.Detail>
                </Label>
              ))}

              <Checkbox
                className="ml-1"
                style={{ top: "2px", position: "relative" }}
                toggle
                label="Asset Register Summary"
                checked={assetRegisterSummary}
                onClick={() =>
                  this.setState({
                    searchParams: {
                      ...this.state.searchParams,
                      assetRegisterSummary: !assetRegisterSummary,
                    },
                  })
                }
              />
              <Button
                icon="user profile"
                color="blue"
                floated="right"
                labelPosition="right"
                disabled={!selectedOperator}
                loading={this.state.loading}
                onClick={() =>
                  this.props.setAssetOwnershipModal({
                    open: true,
                    operator: selectedOperator,
                  })
                }
                content="Asset Ownership Profile"
              />
              <Dropdown
                text="New"
                icon="add"
                floating
                floated="right"
                positive
                as={Button}
                labeled
                button
                color="green"
                className="ml-1 icon"
                labelPosition="right"
                disabled={
                  !this.state.searchParams.selectedOperator ||
                  this.state.loading
                }
                loading={this.state.loading}
              >
                <Dropdown.Menu>
                  <Dropdown.Header icon="add" content="Select Item to Create" />
                  <Dropdown.Item onClick={() => this.onNewClick("DP")}>
                    Depot
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => this.onNewClick("MU")}>
                    Manufacturer
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => this.onNewClick("MT")}>
                    Category
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => this.onNewClick("MA")}>
                    Machine Asset
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => this.onNewClick("CB")}>
                    Cabinet Type
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => this.onNewClick("GT")}>
                    Game Title/Pack
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => this.onNewClick("NA")}>
                    Note Acceptor
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => this.onNewClick("SP")}>
                    Supplier
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <Grid stretched className="height-100 gs-flex-container-vertical">
              <Grid.Row className="flex-stretch">
                <Grid.Column width="6">
                  <div className="table-overflow flex-stretch-vertical">
                    <EGMTree
                      selectedNode={this.state.selectedNode}
                      assets={this.state.assets}
                      onClick={this.handleNodeClick}
                    />
                  </div>
                </Grid.Column>
                <Grid.Column
                  width="10"
                  stretched
                  className="gs-flex-container-vertical"
                >
                  <div className="table-overflow flex-stretch-vertical">
                    {loading && (
                      <Dimmer active inverted>
                        <Loader active />
                      </Dimmer>
                    )}
                    {this.state.selectedNode.id !== null && (
                      <Grid padded relaxed="very" celled>
                        <Grid.Row>
                          <Grid.Column width="16">
                            <Header>
                              {this.state.selectedNode.name}
                              {this.state.grid !== null &&
                                this.state.grid.data.length > 0 && (
                                  <Button
                                    compact
                                    color="blue"
                                    content="Install History"
                                    onClick={() =>
                                      this.props.showInstallHistoryModal(
                                        this.state.grid,
                                      )
                                    }
                                    className="ml-1"
                                  />
                                )}
                            </Header>
                            <OptionsList
                              options={this.mapChanged(
                                this.state.selectedOptions.main,
                              )}
                              onChange={this.handleChangeValue}
                            />
                          </Grid.Column>
                        </Grid.Row>
                        {(this.state.selectedOptions.operational.length > 0 ||
                          this.state.selectedOptions.ownership.length > 0) && (
                          <Grid.Row>
                            {this.state.selectedOptions.operational.length >
                              0 && (
                              <Grid.Column width="8">
                                <Header>Operational Configuration</Header>
                                <OptionsList
                                  className="mt-2"
                                  options={this.mapChanged(
                                    this.state.selectedOptions.operational,
                                  )}
                                  onChange={this.handleChangeValue}
                                />
                              </Grid.Column>
                            )}
                            <Grid.Column
                              width={
                                this.state.selectedOptions.operational.length >
                                0
                                  ? 8
                                  : 16
                              }
                            >
                              <Header>Ownership Details</Header>
                              <OptionsList
                                className="mt-2"
                                options={this.mapChanged(
                                  this.state.selectedOptions.ownership,
                                )}
                                onChange={this.handleChangeValue}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )}
                      </Grid>
                    )}
                  </div>
                  <div className="mt-1 flex-shrink">
                    <Button
                      icon="save"
                      positive
                      labelPosition="right"
                      loading={this.state.loading}
                      disabled={
                        this.state.selectedNode.id === 0
                          ? !this.isAllValid(this.state.selectedOptions) ||
                            this.state.loading ||
                            !selectedOperator ||
                            this.state.selectedOptions.length < 1
                          : !this.isValid() ||
                            !selectedOperator ||
                            this.state.loading ||
                            this.state.selectedOptions.length < 1
                      }
                      onClick={this.handleSave}
                      content={
                        selectedNode.id === 0 ? "Create" : "Save Changes"
                      }
                    />

                    {selectedNode.type === "MA" && selectedNode.id === 0 && (
                      <Checkbox
                        toggle
                        className="ml-1"
                        label="Create Another Asset?"
                        onChange={() =>
                          this.setState({ createAnother: !createAnother })
                        }
                        checked={createAnother}
                      />
                    )}

                    {this.state.doDelete && (
                      <Button
                        floated="right"
                        negative
                        icon="delete"
                        content="Delete Asset"
                        onClick={this.handleDelete}
                      />
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    operators: state.operators.filter((x) => x.value !== -1),
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, {
  showInstallHistoryModal,
  setAssetOwnershipModal,
  fetchOperators,
  confirmModal,
  showSuccessAlert,
})(AssetAdminView);
